import React, { useEffect, useState } from "react";
import Profilesidebar from "./../components/Element/Profilesidebar";
import BankDetailForm from "../components/Element/SideBarForms/BankDetailForm";
import { isMobileOrLaptop } from "../services/CheckDevice";
import ProfileSideBarMobile from "../components/Element/ProfileSideBarMobile";

const BankDetails = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice && checkDevice == "Mobile" ? (
                  <ProfileSideBarMobile page="bank-details" />
                ) : (
                  <Profilesidebar page="bank-details" />
                )}
                <div className="col-xl-9 col-lg-8 m-b30">
                  <BankDetailForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BankDetails;
